import {IController, IModule} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {Debugger} from "debug";

const debug: Debugger = require('debug')('ÅrshjulskjemaKontroller');
const css = require('./årshjulinnslag.scss');


export class ÅrshjulinnslagKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wmGruppeAarshjulinnslag', {
                bindings: {innslag: '<'},
                controller: ÅrshjulinnslagKontroller.forInjisering(),
                template: require('./årshjulinnslag.html')
            });
    }

    static forInjisering() {
        return [ÅrshjulinnslagKontroller];
    }

    innslag: l.ÅrshjulInnslagModell; //settes via bindings/$onChanges

    sluttUke(){
        const ukenr = this.innslag.startuke + this.innslag.antallUker - 1;
        return ukenr > 52 ? ukenr - 52 : ukenr;
    }
}
